<template>
	<div id="admin_details">
		<div style="width: 100%;height: auto;background-color: white;">
			<img :src="Data.projectImg|addPath" style="margin:0px 5%;width: 90%;height: auto;" />
		</div>
		<div style="background-color: white;font-size: 14px;">
			<div class="org_item" style="margin-top: 0px;">
				<van-icon name="manager-o" /> <span class="org_span">活动地点 : {{Data.serveArea}} - {{Data.serveAddress}}</span>
			</div>
			<div class="org_item" style="margin-top: 0px;">
				<van-icon name="manager-o" /> <span class="org_span">服务类别 : {{Data.projectClassify}}</span>
			</div>
			<div class="org_item">
				<van-icon name="phone-o" /> <span class="org_span">服务对象: {{Data.serveObject}}</span>
			</div>
			<div class="org_item">
				<van-icon name="smile-comment-o" /> <span class="org_span">招募日期: {{Data.signupTimeStart|formatDate}} 至 {{Data.signupTimeEnd|formatDate}}</span>
			</div>
			<div class="org_item">
				<van-icon name="free-postage" /> <span class="org_span">活动日期: {{Data.startTime|formatDate}} 至 {{Data.endTime|formatDate}}</span>
			</div>
			<div class="org_item">
				<van-icon name="info-o" /> <span class="org_span">发布日期 : {{Data.createTime|formatDate}}</span>
			</div>
			<div class="org_item">
				<van-icon name="flag-o" /> <span class="org_span">服务时数 : {{Data.serverTime}}</span>
			</div>
			<div class="org_item">
				<van-icon name="flag-o" /> <span class="org_span">能量值 : {{Data.serverPoint}}</span>
			</div>
			<div class="org_item">
				<van-icon name="flag-o" /> <span class="org_span">招募人数 : {{Data.positionPopluation}}</span>
			</div>
			<div class="org_item">
				<van-icon name="location-o" /> <span class="org_span">志愿者保障 :</span><br />
				<div style="margin-left: 6%;">
					<van-tag color="orangered" plain v-for="item in tags" style="margin: 5px;">{{item}}</van-tag>
				</div>
			</div>
		</div>
		<div style="margin-top: 5px;height: auto;background-color: white;min-height: 100px;">
			<div style="padding-top: 5px;">
				<p style="margin: 1px 5%;color: gray;border-left: 3px solid red;">&nbsp;组织介绍</p>
			</div>
			<div style="margin: 5%;width: 90%;" v-html="html_decode(Data.projectDescribe)" id="details">
			</div>
			<div style="display: flex;background-color: white;flex-flow: column;text-align: center;font-size: 20px;">
				<p>签到二维码</p>
				<div id="qrcode" style="margin: auto;"></div>
			</div>
		</div>
		<van-button v-if="show" @click="edit" size="large" style="width: 95%;margin: 10px 2.5%;background-color:orangered;color: white">活动编辑</van-button>
		<van-button v-if="show1" @click="menber" size="large" style="width: 95%;margin: 10px 2.5%;background-color:orangered;color: white">活动成员</van-button>
		<van-button v-if="Data.isEnd==0" @click="close" size="large" style="width: 95%;margin: 10px 2.5%;background-color:gray;color: white">活动关闭</van-button>
		<van-button v-if="show1" @click="settlement" size="large" style="width: 95%;margin: 10px 2.5%;background-color:orangered;color: white">活动结算</van-button>
	</div>
</template>

<script>
	import { Cell, CellGroup, Dialog, Pagination, NavBar, Popup, Search, Loading, Toast, Icon, Area, Picker, Button, Tag } from 'vant';
	import axios from 'axios';
	import store from '@/store/store.js';
	import global from '@/api/global';
	import QRCode from 'qrcodejs2'
	import { htmlspecialchars_decode, formatDate } from '@/js/common.js';
	import Vue from 'vue';
	import VueCookies from 'vue-cookies';
	import areaList from '@/js/area.js';
	Vue.use(VueCookies);
	export default {
		filters: {
			formatDate(time) {
				return formatDate(time, 'yyyy-MM-dd');
			},
			addPath(path) {
				return global.resoursePhoto + "/" + path;
			}
		},
		components: {
			[Cell.name]: Cell,
			[CellGroup.name]: CellGroup,
			[Dialog.name]: Dialog,
			[Pagination.name]: Pagination,
			[NavBar.name]: NavBar,
			[Popup.name]: Popup,
			[axios.name]: axios,
			[Search.name]: Search,
			[Loading.name]: Loading,
			[Toast.name]: Toast,
			[Icon.name]: Icon,
			[Area.name]: Area,
			[Picker.name]: Picker,
			[Button.name]: Button,
			[Tag.name]: Tag
		},
		data() {
			return {
				Data: {
					projectName: "", //活动名称
					projectClassify: "", //服务类别
					teamId: "", //所属组织
					startTime: "", //开始时间
					endTime: "", //结束时间
					signupTimeStart: "", //报名开始时间
					signupTimeEnd: "", //报名结束时间
					serveArea: "", //地区
					contactName: "", //地区代码
					serveAddress: "", //详细地址
					serveObject: "", //服务对象
					projectDescribe: "", //活动介绍
					positionPopluation: "", //招募人数
					volunteerBenefit: "", //志愿者保障
					serverTime: "", //服务时长
					projectImg: "", //封面图片
					serverPhone: "", //联系方式
					serverPoint: "", //正能量值
					issend: "", //是否推送
					createTime: "", //发布时间
					isEnd: "",
					contactPhone: "", //组织者id
				},
				show: false, //活动编辑按钮
				show1: false, //活动成员
				tags: [] //标签
			}
		},
		created: function() {
			this.getInfo();
		},
		mounted() {
			this.qrcode();
		},
		methods: {
			close() {
				axios({
					method: 'post',
					url: global.baseURL + 'appsite/activity/close',
					params: {
						"auth_token": $cookies.get("auth_token"),
						"id": this.$route.query.id
					}
				}).then((resp) => {
					if(resp.data.status==1) {
						Toast(resp.data.msg)
						setTimeout(() => {
							this.$router.go(0);
						}, 1000);
					}else{
						Toast(resp.data.msg)
					}
				}).catch(resp => {

				});
			},
			qrcode() {
				let qrcode = new QRCode('qrcode', {
					width: 100,
					height: 100, // 高度  
					text: global.baseURL + 'appsite/sign/sign?id=' + this.$route.query.id // 二维码内容  
					// render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）  
					// background: '#f0f'  
					// foreground: '#ff0'  
				})
			},
			timeText(time, isEnd) {
				if(isEnd == 1) {
					return false;
				}
				var from_date = new Date(formatDate(time, 'yyyy-MM-dd'));
				var end_date = new Date(formatDate(new Date(), 'yyyy-MM-dd'));
				if((end_date - from_date) / 86400000 > 0) {
					return false;
				} else {
					var time_different = (from_date - end_date) / 86400000;
					return true;
				}
			},
			html_decode(content) {
				return htmlspecialchars_decode(content + "");
			},
			login() {
				this.$router.push({
					path: '/login'
				});
			},
			getInfo() { //获取活动信息
				Toast.loading({
					mask: true,
					message: '加载中...',
					duration: 0
				});
				axios({
					method: 'get',
					url: global.baseURL + 'appsite/activity/select',
					params: {
						"id": this.$route.query.id
					}
				}).then((resp) => {
					this.Data = resp.data.data;
					this.tags = this.Data.volunteerBenefit.split(",");
					axios({
						method: 'post',
						url: global.baseURL + 'appsite/phoneUser/selectUserInfo',
						params: {
							"auth_token": $cookies.get("auth_token")
						}
					}).then((resp) => {
						if(resp.data.data.user.id == this.Data.contactPhone && this.Data.status != 2) {
							this.show = true;
						}
						if(this.Data.status == 1) {
							this.show1 = true;
						}
					}).catch(resp => {

					});
					Toast.clear();
				}).catch(resp => {
					Toast.clear();
					Toast.fail('请求失败');
				});
			},
			edit() { //编辑活动跳转
				this.$router.push({
					path: '/activity_edit',
					query: { //路由传参时push和query搭配使用 ，作用时传递参数
						id: this.$route.query.id
					}
				});
			},
			menber() { //活动成员列表
				this.$router.push({
					path: '/activity_menber',
					query: { //路由传参时push和query搭配使用 ，作用时传递参数
						id: this.$route.query.id
					}
				});
			},
			settlement() {
				this.$router.push({
					path: '/activity_settlement',
					query: { //路由传参时push和query搭配使用 ，作用时传递参数
						id: this.$route.query.id,
						serverTime: this.Data.serverTime,
						serverPoint: this.Data.serverPoint
					}
				});
			}
		}
	}
</script>

<style>
	#admin_details .active_button {
		background-color: orangered !important
	}
	
	#admin_details .org_item {
		margin: 10px 5%;
	}
	
	#admin_details .org_span {
		vertical-align: middle;
		margin-left: 6px;
	}
	
	#admin_details .van-icon,
	#admin_details .van-icon::before {
		vertical-align: middle;
	}
	
	#details * {
		max-width: 100%;
	}
</style>